import Player_Myyja2 from '../../../../../images/svg/Player_Myyja2.svg'
import Player_Vastaaja2 from '../../../../../images/svg/Player_Vastaaja2.svg'

const MessageBuble = ({ message }) => {
    return (
        <div className={`message-buble-container 
                        bubble-position-${message.align} `}>
            <div className={`message-buble
                        bubble-color-${message.speaker}`}>
                {message.message}
            </div>
            {!message.sameSpeaker &&
                <img src={message.speaker === 'seller' ?
                    Player_Myyja2 : Player_Vastaaja2}
                    className='speaker-role-bubble' alt='' />}
        </div>
    )
}

export default MessageBuble